import { makeStyles } from '@material-ui/core/styles';
import { backgroundRectangle, estilosTextosPrincipales, colores } from '../../../AppStyle';

const useStyles = () => {
    const style = makeStyles({
        backgroundRectangle: {
            ...backgroundRectangle,
            marginBottom: '2%',
            padding: '1% 0% 0% 2%'
        },
        tituloPagina: {
            ...estilosTextosPrincipales.encabezadoH3,
            color: colores.escalaGrises.cien,
            fontWeight: 'bold',
        },
        gridTitulo: {
            display: 'flex',
            flexDirection: 'row',
            marginTop: '2%',
            marginLeft: '5%',
            width: '90%'
        },
        classBackdrop: {
            zIndex: 1,
            color: '#fff',
        }
    });
    return { style }
}

export default useStyles;